import React, { useEffect, useState } from "react";
import { useUser } from "../../context/UserContext";
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import Button from '../UI/Button';

const LogsPage = () => {
    const { logout, hasPermission } = useUser();
	const canView = hasPermission("logs", "view");
	const canDelete = hasPermission("logs", "delete");


    const [logs, setLogs] = useState([]);
    const [types, setTypes] = useState([]);
    const [typeFilter, setTypeFilter] = useState("");
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);


    const fetchLogs = async () => {
        const params = new URLSearchParams({
            type: typeFilter,
            search,
            page,
            limit,
        });

        const res = await fetchWithAuth(
            `${process.env.REACT_APP_API_URL}/logs?${params.toString()}`,
            {},
            logout
        );
        const data = await res.json();
        setLogs(data.logs);
        setTotal(data.total);
    };

    useEffect(() => {
        fetchLogs();
    }, [typeFilter, search, page]);


    useEffect(() => {
        const fetchTypes = async () => {
            try {
                const res = await fetchWithAuth(
                    `${process.env.REACT_APP_API_URL}/enum/logTypes`,
                    {},
                    logout
                );
                const data = await res.json();

                setTypes(data);
            } catch (err) {
                console.error("Ошибка при загрузке типов логов:", err);
                setTypes([]);
            }
        };

        fetchTypes();
    }, []);

	if (!canView) {
		return <div className="text-red-500 text-center text-2xl">У вас нет прав на просмотр логов</div>;
	}

    const handleDelete = async (logId) => {
        if (!window.confirm("Удалить это событие?")) return;

        try {
            const res = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/logs/${logId}`,
                {
                    method: "DELETE",
                },
                logout
            );

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            fetchLogs(); // обновим список логов
        } catch (err) {
            console.error("Ошибка удаления лога:", err);
        }
    };



    const totalPages = Math.ceil(total / limit);

    return (
        <div className="p-6 text-[#CCCCCC] space-y-4">
            <h1 className="text-2xl font-bold">Журнал событий</h1>

            <div className="flex gap-4">
                <input
                    type="text"
                    placeholder="Поиск по имени"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="px-3 py-2 bg-[#1E1E1E] border border-[#3E3E42] rounded"
                />
                <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    className="px-3 py-2 bg-[#1E1E1E] border border-[#3E3E42] rounded"
                >
                    <option value="">Все типы</option>
                    {types.map((type) => (
                        <option key={type} value={type}>
                            {type}
                        </option>
                    ))}
                </select>
            </div>

            <table className="w-full table-auto border border-[#3E3E42]">
                <thead className="bg-[#252526]">
                    <tr>
                        <th className="p-2 border border-[#3E3E42]">
                            ID пользователя
                        </th>
                        <th className="p-2 border border-[#3E3E42]">
                            Логин пользователя
                        </th>
                        <th className="p-2 border border-[#3E3E42]">
                            Тип события
                        </th>
                        <th className="p-2 border border-[#3E3E42]">
                            Описание
                        </th>
                        <th className="p-2 border border-[#3E3E42]">Дата</th>
                        <th className="p-2 border border-[#3E3E42]">
                            Действия
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {logs.map((log) => (
                        <tr key={log._id}>
                            <td className="p-2 border border-[#3E3E42]">
                                {log.userId}
                            </td>
                            <td className="p-2 border border-[#3E3E42]">
                                {log.username}
                            </td>
                            <td className="p-2 border border-[#3E3E42]">
                                {log.type}
                            </td>
                            <td className="p-2 border border-[#3E3E42]">
                                {log.description}
                            </td>
                            <td className="p-2 border border-[#3E3E42]">
                                {new Date(log.createdAt).toLocaleString()}
                            </td>
                            <td className="p-2 border border-[#3E3E42] flex gap-2">
                                {canDelete && <Button
                                    onClick={() => handleDelete(log._id)}
                                    variant="danger"
                                >
                                    Удалить
                                </Button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="mt-4 flex gap-2">
                {Array.from({ length: totalPages }, (_, i) => (
                    <Button
                        key={i}
                        onClick={() => setPage(i + 1)}
                        variant="pagination"
                        className={page === i + 1 ? "bg-[#3E3E42] text-white" : ""}
                    >
                        {i + 1}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default LogsPage;
